export class IssuingEntity {
  id?: number;
  name: string;
  code: string;
  complianceBuyerAuthorized: boolean;
}
